import type { ReactNode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { I18nProvider } from '@/i18n';
import { QueryProvider } from '@/components/providers/QueryProvider';
import { ToastProvider } from '@/components/ui/toast';
import ScrollToTop from '@/components/ui/ScrollToTop';

interface AppProvidersProps {
  children: ReactNode;
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <I18nProvider>
        <QueryProvider>
          <ToastProvider>{children}</ToastProvider>
        </QueryProvider>
      </I18nProvider>
    </BrowserRouter>
  );
}
